import { Navigate, useLocation } from "react-router-dom";
import React, { ReactElement, ReactNode, useContext } from "react";

import AuthContext from "./context/authContext/AuthContext";
import { AuthContextType } from "./context/authContext/types";

interface ProtectedRouteProps {
  children: ReactNode;
}

const ProtectedRoute = ({ children }: ProtectedRouteProps): ReactElement => {
  const { isAuthenticated, loading } = useContext(
    AuthContext
  ) as AuthContextType;
  const location = useLocation();

  if (loading) {
    return <></>;
  }

  return isAuthenticated ? (
    <>{children}</>
  ) : (
    <Navigate to="/sign-in" state={{ from: location }} replace />
  );
};

export default ProtectedRoute;
